import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { saveTokenData } from 'api/AuthApi';
import { handleAuthenticationChange } from 'features/security/securitySlice';
import { useDispatch } from 'react-redux';
import { authApi } from 'features/security/authApi';
import { ROUTES } from 'config/routes';

export default function SSO() {
    const { code } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const [getSsoTokenQuery] = authApi.useLazyGetSsoTokenQuery();

    useEffect(() => {
        if (!code) {
            return;
        }

        getSsoTokenQuery(code, false).then((result) => {
            if (result.status === 'rejected' || !result.data) {
                history.push('/');
                return;
            }

            saveTokenData(result.data.token, result.data.refreshToken).then(() => {
                dispatch(handleAuthenticationChange());
                history.push(ROUTES.documents.base);
            });
        });
    }, [code]);

    return <div>Validating token, please wait...</div>;
}
